import React from 'react';
import { WebsiteDesignProps } from './types';
import { Settings, Watch, Key, PenTool } from 'lucide-react';
import { Button } from "@/components/ui/button";

const SteampunkWorkshop: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Clockwork Institute";

    return (
        <div className="bg-[#2b1d14] text-[#d4af37] min-h-screen font-serif selection:bg-[#d4af37] selection:text-[#2b1d14]">
            {/* Texture */}
            <div className="fixed inset-0 pointer-events-none opacity-20" style={{backgroundImage: `url("https://www.transparenttextures.com/patterns/black-scales.png")`}}></div>

            <nav className="relative z-20 border-b-4 border-[#8b4513] bg-[#1a110a] p-6 flex justify-between items-center shadow-lg">
                <div className="flex items-center gap-3">
                    <Settings className="animate-spin-slow text-[#cd7f32]" size={32} />
                    <span className="text-2xl font-bold uppercase tracking-widest text-[#d4af37] drop-shadow-md font-mono">{schoolName}</span>
                </div>
                <div className="flex gap-4">
                     <Button variant="outline" className="border-[#cd7f32] text-[#cd7f32] hover:bg-[#cd7f32] hover:text-[#2b1d14] font-bold uppercase tracking-widest rounded-none">
                         Login
                     </Button>
                </div>
            </nav>

            <main className="container mx-auto px-6 py-16 relative z-10 flex flex-col items-center">
                 <div className="w-full max-w-4xl border-8 border-[#8b4513] bg-[#2b1d14] p-2 rounded-lg shadow-2xl mb-16 relative">
                     <div className="border border-[#d4af37] p-12 text-center relative overflow-hidden">
                         {/* Gear Decoration */}
                         <Settings size={200} className="absolute -top-20 -right-20 text-[#3e2723] opacity-50 animate-spin-slow" />
                         <Settings size={150} className="absolute -bottom-20 -left-20 text-[#3e2723] opacity-50 animate-reverse-spin" />

                         <h1 className="text-5xl md:text-7xl font-bold text-[#d4af37] mb-6 uppercase tracking-wider relative z-10" style={{textShadow: '2px 2px 0px #000'}}>
                             Forging <br/> The Future
                         </h1>
                         <p className="text-xl text-[#cd7f32] mb-10 font-mono relative z-10">
                             Innovation powered by steam, steel, and intellect.
                         </p>
                         <Button className="bg-[#8b4513] hover:bg-[#a0522d] text-[#e5e5e5] border-2 border-[#d4af37] px-8 py-6 text-lg font-bold uppercase rounded-sm shadow-[4px_4px_0_0_#000] relative z-10">
                             Enter Workshop
                         </Button>
                     </div>
                     
                     {/* Rivets */}
                     <div className="absolute top-2 left-2 w-3 h-3 rounded-full bg-[#d4af37] shadow-inner"></div>
                     <div className="absolute top-2 right-2 w-3 h-3 rounded-full bg-[#d4af37] shadow-inner"></div>
                     <div className="absolute bottom-2 left-2 w-3 h-3 rounded-full bg-[#d4af37] shadow-inner"></div>
                     <div className="absolute bottom-2 right-2 w-3 h-3 rounded-full bg-[#d4af37] shadow-inner"></div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                     {[
                         { icon: Watch, title: "Precision", desc: "Every second counts in our labs." },
                         { icon: Key, title: "Discovery", desc: "Unlock the secrets of matter." },
                         { icon: PenTool, title: "Craft", desc: "Hands-on engineering mastery." },
                     ].map((item, i) => (
                         <div key={i} className="bg-[#1a110a] border border-[#8b4513] p-8 text-center hover:bg-[#2b1d14] hover:border-[#d4af37] transition-colors rounded">
                             <item.icon className="mx-auto text-[#cd7f32] mb-4" size={40} />
                             <h3 className="text-xl font-bold text-[#d4af37] uppercase tracking-widest mb-2">{item.title}</h3>
                             <p className="text-[#a1887f] font-mono text-sm">{item.desc}</p>
                         </div>
                     ))}
                 </div>
            </main>
        </div>
    );
};

export default SteampunkWorkshop;
